import axios from 'axios';

import { toast } from 'react-toastify';
import { toastSettings } from './toastSettings';

const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  config => config,

  error => Promise.reject(error),
);

apiClient.interceptors.response.use(
  response => response,
  error => {
    toast('Network error', toastSettings);

    return Promise.reject(error);
  },
);

export { apiClient };
